import { HTMLAttributes } from 'react';
import { foundationRadiusTokens, foundationSemantic } from '../../foundation';
import { cx } from './utils';

type ChipVariant = 'neutral' | 'selected' | 'interactive' | 'dismissible';

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
}

const variantClasses: Record<ChipVariant, string> = {
  neutral: foundationSemantic.chip.neutral,
  selected: foundationSemantic.chip.selected,
  interactive: foundationSemantic.chip.interactive,
  dismissible: foundationSemantic.chip.dismissible
};

export default function Chip({ variant = 'neutral', className, ...props }: ChipProps) {
  return (
    <span
      className={cx(`inline-flex items-center ${foundationRadiusTokens.full} px-2 py-0.5 text-xs font-medium`, variantClasses[variant], className)}
      {...props}
    />
  );
}

export type { ChipProps, ChipVariant };
